import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Layout } from 'antd';
import PriceConfigure from './components/PriceConfigure';
import { checkPermissionsHOC } from '../../App/CheckPermissions';
import { NotFound } from '../../App/components/NotFound';

const mapStateToProps = state => ({ views_permissions: state.App.Permissions.views_permissions });

export default connect(mapStateToProps, null)(checkPermissionsHOC(class Index extends Component {
    componentWillUnmount() {
        this.props.dispatch({ type: 'RESET_PERMISSIONS' });
    }

    render() {
        const { views_permissions } = this.props;
        const view_parent_access = views_permissions['view://PlatformManagement/Price-o-matic_update'];
        if (!view_parent_access) {
            return <NotFound />;
        }
        return (
            <Layout className="priceomatic-update-container">
                <h3 className="page-title">Configure Price-o-Matic</h3>
                <h3 className="page-subhead subhead">
                    Configure the lead rules that come into the buying division of
                    SuperBike Factory.
                </h3>
                <PriceConfigure />
            </Layout>
        );
    }
}, ['view://PlatformManagement/Price-o-matic_update']));



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Price-o-matic_update/index.js